import React from 'react'
import {useNavigate} from "react-router-dom";
import {useAuth} from "../../providers/AuthProvider";


const TalentReviewCompleted = (props) => {

    const {auth, logout, appropriate} = useAuth();
    const navigate = useNavigate();

    return (
        <div className={'talent-portal-page'}>
            <div className="nav-container">
                <div className="nav-info">

                    <div className="nav-welcome">
                        <p></p>
                    </div>
                </div>
            </div>
            <div className="talent-portal-welcome">
                <div className="container mx-auto">
                    <div className="welcome-panel">
                        <div className="welcome-top text-center">
                            <h1>Review Completed</h1>
                            <p className="welcome-text">Hello {auth?.first_name}, unfortunately at this time your application to join
                                Wripple was not accepted. If you wish to apply again in the future, please send an email
                                to <a className="btn-link btn-link-info p-0" href="mailto:talentteam@wripple.com">
                                    talentteam@wripple.com
                                </a> and we will restart your application. We generally will
                                reconsider applications every six months</p>
                        </div>

                        <div className="flex flex-row items-center justify-center py-6 md:flex">
                            <button className="btn btn-dark" onClick={() => logout()}>
                                Sign Out
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default TalentReviewCompleted;